import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {ProductosReferenciasDesembolsos} from "../_models/productos-referencias-desembolsos";

@Injectable({
  providedIn: 'root'
})
export class ProductoReferenciaMetodoDesembolsoService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosReferenciasDesembolsos';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoPorId(idProducto: string) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto).pipe( map( res => res as ProductosReferenciasDesembolsos[]) );
  }

  bulk(data: ProductosReferenciasDesembolsos[]){
    return this.httClient.post(this.rutServicio + '/bulk', data).pipe(map(res => res  as ProductosReferenciasDesembolsos[]));
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductosReferenciasDesembolsos ) );
  }

  crear( regCrear: ProductosReferenciasDesembolsos ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductosReferenciasDesembolsos ) );
  }

  actualizar( regActualizar: ProductosReferenciasDesembolsos ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
